module.exports = __webpack_public_path__ + "static/img/save-time.14c31a9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img-text/images/save-time.svg
// module id = 57Hz
// module chunks = 26